module.exports = __webpack_public_path__ + "img/detail_pup1.2f835ad1.png";